<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row v-if="false">
      <v-col cols="12" md="8">
        <v-btn
          text
          class="text-capitalize"
          href="#">
          <v-icon left>mdi-text-box-check-outline</v-icon> Daftar tugas
        </v-btn>
        <v-btn
          text
          class="text-capitalize"
          href="#">
          <v-icon left>mdi-folder-text</v-icon> Untuk diperiksa
        </v-btn>
        <v-btn
          text
          class="text-capitalize"
          href="#">
          <v-icon left>mdi-calendar-month</v-icon> Kalender
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          dense
          prepend-inner-icon="search"
          v-model="paramclass.keyword"
          label="Nama kelas"
          name="keyword">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="datalist.length > 0">
      <v-col
        class="d-flex" style="flex-direction:column"
        cols="12"
        md="4"
        v-for="(kelas, i) in datalist"
        :key="i">
        <v-card
          class="flex-grow-1"
          outlined>
          <v-img
            height="80px"
            :lazy-src="require('../../assets/default.jpg')"
            :src="api + '/upload/kelas/' + kelas.bgimg_class">
            <v-app-bar
              dark
              flat
              color="rgba(0, 0, 0, 0)">
              <v-toolbar-title class="title pl-0">
                <router-link
                  class="white--text text-decoration-none"
                  :to="{ name: 'Detailclass', query: { berita: kelas.id_class } }">
                  {{ kelas.nama_class }}
                </router-link>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </v-app-bar>
          </v-img>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <div class="font-weight-bold">Semester {{ kelas.semester_class }}</div>
                <div class="font-weight-bold">{{ kelas.matkul_class }}</div>
                <div class="font-weight-bold">{{ kelas.angkatan_class }} - {{ kelas.mhs_class }}</div>
              </v-col>
              <v-col cols="12" md="12" class="py-0">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" md="12">
                <div v-html="kelas.desc_class"></div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <infinite-loading :identifier="infiniteId" @infinite="getClass">
          <div slot="spinner">Loading...</div>
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';

export default {
  name: 'Listclass',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    datalist: [],
    listcategory: ['job-fair', 'motivation'],
    panduan: null,
    paramclass: {
      keyword: '',
      limit: 15,
      offset: 0,
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    infiniteId: +new Date(),
  }),
  mounted() {
    // this.getClass();
    if (this.$route.query.reference && this.$route.query.reference !== '') {
      this.check.reference = this.$route.query.reference;
      // this.checkAtletByNik();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    getClassFilter() {
      this.paramclass.offset = 0;
      this.datalist = [];
      this.infiniteId += 1;
    },
    getClass($state) {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kelas/teacher',
            {
              params: this.paramclass,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.paramclass.offset += this.paramclass.limit;
                  this.datalist.push(...resdata.data);
                  if (this.datalist.length < this.paramclass.offset) {
                    $state.complete();
                  } else {
                    $state.loaded();
                  }
                } else {
                  $state.complete();
                }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
    checkAtletByNik() {
      this.alertdata.show = false;
      if (this.check.reference !== '') {
        this.hasil.data = [];
        this.loading.check = true;
        this.axios
          .post(
            this.api + '/public/checkdata',
            qs.stringify(
              this.check,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.hasil.data = resdata.data;
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.check = false;
          });
      }
    },
    submitCheckData() {
      this.alertdata.show = false;
      if (this.$refs.formcheck.validate()) {
        // this.checkAtletByNik();
      }
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
